<template>
<Teleport to="body">
  <div v-if="is_show" class="splash ">
    <BehfamLOGO style="right: 5vw;"/>
  </div>
</Teleport>
</template>

<script>
import BehfamLOGO from "@/components/Icons/BehfamLOGO.vue";

export default {
  name: "Splash",
  components: {BehfamLOGO},
  data(){
    return{
      is_show: true
    }
  },
  mounted() {
    setTimeout(()=>{
      this.is_show = !this.is_show
    },2000)
  }
}
</script>

<style scoped>
h2{
  font-size: 1.4vw;
  display: none;
}
.splash{
  width: 100%;
  height: 100vh;
  background: rgba(255, 255, 255, 0.9);
  position: fixed;
  top: 0;
  right: 0;
  z-index: 99999999999999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

}
.loader {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: inline-block;
  border-top: 4px solid #FFF;
  border-right: 4px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}
.loader::after {
  content: '';
  box-sizing: border-box;
  position: absolute;
  left: 0;
  top: 0;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border-left: 4px solid #0077ff;
  border-bottom: 4px solid transparent;
  animation: rotation 0.5s linear infinite reverse;
}
@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>